<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">提案流程</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">提案类型</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">提案投票统计</a></p>
          <!-- <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">test</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">test</a></p> -->
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">链上治理</div>
      <div id="box1" class="p4">提案流程</div>
      <div class="p3">提案的总体流程如下所示：</div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/governance1.png" alt=""></div>
      <div class="p3">详细信息：</div>
      <div class="p3">
        <ol style="padding-left:50px;word-break:break-all">
          <li>提案人在发起提案时应承诺 FAX，以防止恶意发起提案。</li>
          <li>投票参与者为债券FAX持有人，以下两种除外</li>
          <div class="p3">
            <ul style="padding-left:30px;word-break:break-all">
              <li>a.进入 vote_period 后，FAX 持有者与验证者的绑定/解除绑定</li>
              <li>b.FAX 持有者在进入 vote_period 后成为验证者</li>
            </ul>
          </div>
          <li>投票权重取决于债券中 FAX 的数量。</li>
          <li>为防止重复投票：</li>
          <div class="p3">
            <ul style="padding-left:30px;word-break:break-all">
              <li>a.投票周期小于 unbond_period。投票期最短为 72 小时（可根据提案类型调整）。</li>
              <li>b.如果委托人在验证人代表他投票之前投票，则验证人投票的权重不包括 FAX 在其债券中的权重。</li>
              <li>c.如果委托人在验证人代表他投票后投票，则投票结果的权重取代验证人代表委托人投票的权重。</li>
            </ul>
          </div>
        </ol>
      </div>
      <div id="box2" class="p4">提案类型</div>
      <div class="p3">FaxChain 针对不同目的提供 4 种类型的提案：</div>
      <div class="p3">
        <ol style="padding-left:50px;word-break:break-all">
          <li>Text Proposal：获取某个话题的网络浏览量。</li>
          <li>参数建议：更改系统参数。</li>
          <li>Delist Proposal：从 DEX 中删除一个代币对。</li>
          <li>软件升级方案： 支持全网升级。</li>
        </ol>
      </div>
      <div class="p3">除文本提案外，提案有四个阶段，包括发起、存款_周期、投票_周期和执行。执行不是文本提案的阶段。</div>
      <div id="box3" class="p4">提案投票统计</div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/governance2.png" alt=""></div>
      <div class="p3">变量的含义：</div>
      <div class="p3">
        <ul style="padding-left:50px;word-break:break-all">
          <li>totalBonded：全网可用于投票的绑定FAX的总和。</li>
          <li>totalVotingPower：参与投票的绑定FAX的总和。</li>
          <li>percentVoting = totalVotingPower / totalBonded。</li>
          <li>Quorum：参与投票者的投票权重阈值（0.334）。</li>
          <li>Threshold： 赞成票占所有非弃权票的比重阈值（0.5）。</li>
          <li>Veto：NoWithVeto 票数占所有票数的权重阈值（0.334）。</li>
          <li>YesInVotePeriod：投票结束前Yes票数占totalBonded比例的权重阈值（0.667）。</li>
          <li>Yes：保税FAX投票的总和 是。</li>
          <li>No：保税FAX投票数的总和。</li>
          <li>NoWithVeto：保税 FAX 投票 NoWithVeto 的总和。</li>
          <li>Abstain：保税 FAX 投票 Abstain 的总和。</li>
        </ul>
      </div>
      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">提案流程</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">提案类型</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">提案投票统计</a></p>
      <!-- <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">test</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">test</a></p> -->
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onchainGovernance',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>